import type { StoreApi, UseBoundStore } from 'zustand';
import { create } from 'zustand';
import { createDriverSlice, driverSelectors } from './createDriverSlice';
import {
  createWalkthroughConductorSlice,
  walkthroughConductorSelectors,
} from './createWalkthroughConductorSlice';
import type { CreateWalkthroughManagerStoreParams, WalkthroughManagerStore } from './types';

export function createWalkthroughSelectors(
  store: UseBoundStore<StoreApi<WalkthroughManagerStore>>,
) {
  return Object.assign(store, {
    hooks: {
      ...driverSelectors(store),
      ...walkthroughConductorSelectors(store),
    },
  });
}

export function createWalkthroughManagerStore(params: CreateWalkthroughManagerStoreParams) {
  const store = create<WalkthroughManagerStore>((set, get) => ({
    ...createDriverSlice(set, get),
    ...createWalkthroughConductorSlice(params, set, get),
  }));

  const storeWithSelectors = createWalkthroughSelectors(store);

  return storeWithSelectors;
}

export type UseCreateWalkthroughManagerStore = ReturnType<typeof createWalkthroughManagerStore>;
